import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import RelectAndIntegrate1Image from "../../../Assets/Images/RelectAndIntegrate1Image.png";
import RelectAndIntegrateIcon from "../../../Assets/Images/RelectAndIntegrateIcon.png"

const LifeIntegration1 = () => {

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 }
        ]
    });


    const styles = StyleSheet.create({
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px",
        },
        image: {
            width: "574px",
            height: "300px",

        },
        content: {
            width: "570px",
            height: "710px",
            display: "flex",
            flexDirection: "column",
            marginTop : "10px"
        },
        imageContainer: {
            width: "574px",
            height: "300px",
        },
        contentDescription: {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            fontFamily : "Lato",
            fontWeight : 400,
            fontSize : "12px",
            lineHeight : "18px",
            color : "#245775"
        },
        icon: {
            width: "68px",
            height: "68px"
        },
        text: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "30px",
            color: "#426B88",
            marginBottom : "2px"
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: "#5795B2",
            borderBottom: "1px solid #5795B2"
        },
        title: {
            width: "183px",
            fontSize: "14px",
            fontFamily: "Lato",
            lineHeight: "18px",
            color: "#5795B2",
            fontWeight: 400,

        },
        titlebold: {
            fontWeight: 700
        },
        details: {
            fontSize: "10px",
            fontFamily: "Lato",
            lineHeight: "16px",
            color: "#5795B2",
            fontWeight: 400,
            width: "73px",
            textAlign: "right"

        },
        textbold: {
            fontWeight: 700
        },
        bold : {
            fontWeight : 700
        }
    });
    return (

        <View style={styles.pagewapper}>
            <View style={styles.header}>
                <View style={styles.title}>
                    <Text style={styles.titlebold}>Quadrant Flow</Text>
                    <Text>Life & Leadership Assessment</Text>
                </View>
                <View style={styles.details}>
                    <Text style={styles.textbold}>Rob Murray</Text>
                    <Text>Atlas Real Estate</Text>
                    <Text>Oct 18, 2024</Text>
                </View>
            </View>
            <View style={styles.content}>
                <Text style={styles.text}>LIFE INTEGRATION</Text>
                <View style={styles.contentDescription}>
                   <View>
                    <Text>1. What key insights from the assessment reflect how you currently live your life?</Text>
                    <Text>2 . Which areas of your life need attention based on your assessment?</Text>
                    <Text>3. How can your strengths from the results help you achieve personal goals?</Text>
                    <Text>4. What personal challenges do the results highlight, and how will you address them?</Text>
                    <Text>5. What habits can you change to align with your strengths and growth areas?</Text>
                    <Text>6. How will you make better decisions in your life using these results?</Text>
                    <Text>7. What do your results say about your relationships, and how can you improve them?</Text>
                    <Text>8. What self-care needs do your results highlight, and how will you meet them?</Text>
                    <Text>9 . What personal goals will you set based on your assessment?</Text>
                    <Text>10. How will you live more aligned with your strengths from the results?</Text>
                   </View>
                   <View>
                    <Text style={styles.bold}>Deeper Reflection:</Text>
                   </View>
                   <View>
                    <Text>1. What experiences from your past do these results remind you of, and how do they shape our current approach to life?</Text>
                    <Text>2. How does the way you see yourself internally match or differ from the results in your assessment?</Text>
                    <Text>3. What deep-seated fears or motivations are influencing the areas of growth identified in your assessment?</Text>
                    <Text>4. What unaddressed emotional patterns or behaviors do the results bring to light, and how will you work on them?</Text>
                    <Text>5. How will you apply these insights to create a lasting change in both your personal life and future decisions?</Text>
                   </View>
                </View>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default LifeIntegration1